import {ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector, Type} from '@angular/core';
import {DrawerComponent} from './drawer.component';

@Injectable({providedIn: 'root'})
export class DrawerService {

    private drawerRef: HTMLElement | null = null;
    private drawerComponentRef: ComponentRef<DrawerComponent> | null = null;

    constructor(private appRef: ApplicationRef,
                private componentFactoryResolver: ComponentFactoryResolver,
                private injector: Injector) {
    }

    open<T>(component: Type<T>, side: 'left' | 'right' = 'right', componentData?: Partial<T>, width: string = '80vw') {
        if (this.drawerRef) return null; // Already open

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DrawerComponent);
        this.drawerComponentRef = componentFactory.create(this.injector);
        const drawerInstance = this.drawerComponentRef.instance;

        drawerInstance.side = side;
        drawerInstance.childComponentType = component;
        drawerInstance.componentData = componentData || {};
        drawerInstance.width = width;

        this.appRef.attachView(this.drawerComponentRef.hostView);
        const domElem = (this.drawerComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

        document.body.appendChild(domElem);
        this.drawerRef = domElem;

        const drawerClosed$ = drawerInstance.closed.subscribe(() => {
            this.appRef.detachView(this.drawerComponentRef!.hostView);
            this.drawerComponentRef!.destroy();
            this.drawerRef = null;
            this.drawerComponentRef = null;
            drawerClosed$.unsubscribe();
        });

        return drawerInstance;
    }

    close() {
        this.drawerComponentRef?.instance?.close();
    }
}
